








































































































































































































































































































































































































import Vue, { PropType } from "vue";
import _ from "lodash";
import ImageUpload from "../../components/Field/ImageUpload.vue";
import { Advertisement } from "@/interfaces/advertisement";
export default Vue.extend({
  components: {
    ImageUpload
  },
  data() {
    return {
      files: {
        image1: undefined,
        image2: undefined,
        image3: undefined,
        image4: undefined,
        image5: undefined
      } as { [key: string]: File | undefined },
      mapUrlValue:
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyC8_6QR7_VFGRPYxmtoTbbk0tCSBbI2UTY&zoom=15&q=Japan"
    };
  },
  computed: {
    mapUrl: {
      get(): string {
        return this.mapUrlValue;
      },
      set: _.debounce(function(this: { mapUrlValue: string }, newVal: string) {
        this.mapUrlValue = newVal;
      })
    },
    formTitle(): string {
      if (this.phase === "input") {
        return "" + this.inputTitle;
      }
      if (this.phase === "confirm") {
        return "" + this.confirmTitle;
      }

      return "";
    },
    hasErrors(): boolean {
      return !_.isEmpty(this.errors);
    }
  },
  props: {
    inputTitle: {
      type: String,
      default: "入力"
    },
    confirmTitle: {
      type: String,
      default: "確認"
    },
    confirmLabel: {
      type: String,
      default: "次へ"
    },
    execLabel: {
      type: String,
      default: "送信"
    },
    backLabel: {
      type: String,
      default: "修正"
    },
    input: {
      type: Object as PropType<Advertisement>,
      default() {
        return {} as Advertisement;
      }
    },
    errors: {
      type: Object as PropType<Map<string, string | unknown>>,
      default() {
        return {} as Map<string, string | unknown>;
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: "input"
    },
    skipConfirmation: {
      type: Boolean,
      default: false
    },
    asChild: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "input.mapParameters"() {
      this.mapUrl =
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyC8_6QR7_VFGRPYxmtoTbbk0tCSBbI2UTY&zoom=15&q=" +
        encodeURIComponent(
          this.input.mapParameters || this.input.storeAddress || ""
        );
    },
    "input.storeAddress"() {
      this.mapUrl =
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyC8_6QR7_VFGRPYxmtoTbbk0tCSBbI2UTY&zoom=15&q=" +
        encodeURIComponent(
          this.input.mapParameters || this.input.storeAddress || ""
        );
    }
  }
});
